import Error500Layout from '../src/components/Error500Layout/Error500Layout';

export { Error500Layout };
